import React from 'react';
import { useIntl } from 'react-intl';

import cx from 'classnames';

import './__disclaimer.scss';

/** Дикслеймер для учеников, что учителя видят историю вставок */
export const CodingProblem__Disclaimer = ({ className }: { className?: string }) => {
    const intl = useIntl();

    const disclaimerText = intl.formatMessage({ id: 'codingProblem.disclaimer.text' });
    const link = intl.formatMessage({ id: 'codingProblem.disclaimer.link' });
    const linkWithoutProtocol = link.split('://')[1];

    return (
        <div className={cx('coding-problem__disclaimer', className)}>
            {disclaimerText}{' '}
            <a href={link} rel="noopener noreferrer" target="_blank">
                {linkWithoutProtocol}
            </a>
        </div>
    );
};
